/**
 * Stable `digest` carried on every SessionTokenUnavailableError. Next
 * strips a server error's message/stack before it reaches a client error
 * boundary but forwards a pre-set `digest` verbatim, so `app/error.tsx`
 * matches on this to turn the error into a re-auth redirect app-wide.
 */
export const REAUTH_REQUIRED_DIGEST = 'REAUTH_REQUIRED';

/**
 * Thrown when a Clerk session exists (`userId` present) but Clerk's
 * `getToken()` returns null — a transient refresh/handshake gap. That
 * session JWT is what we forward to Supabase as the bearer, so callers
 * re-authenticate rather than degrade the request to the anon Postgres
 * role.
 */
export class SessionTokenUnavailableError extends Error {
  readonly digest = REAUTH_REQUIRED_DIGEST;

  constructor(public readonly userId: string) {
    super(`Clerk getToken() returned null for session ${userId}`);

    this.name = new.target.name;
    Object.setPrototypeOf(this, new.target.prototype);

    if ('captureStackTrace' in Error) {
      Error.captureStackTrace(this, new.target);
    }
  }
}
